import vars from '../globals';

const $popup = $('.card-popup');

const openPopup = (e) => {
	let $card = $(e.target).closest('.card');
	let $container = $card.closest('.home-cards__container');
	let id = $card.attr('id');
	let posX = $card.offset().left - $container.offset().left;
	let posY = $card.offset().top - $container.offset().top;

	$popup.css('top', `${posY}px`);
	$popup.css('left', `${posX}px`);
	$popup.removeClass('is-hidden');
	$popup.data('card', id).attr('data-card', id);
	$popup.find(`.card-popup__text--${id}`).removeClass('is-hidden');
};

const hidePopup = () => {
	let $texts = $('.card-popup__text');

	$popup.addClass('is-hidden');

	$texts.each((i, text) => {
		let $text = $(text);

		if (!$text.hasClass('is-hidden')) {
			$text.addClass('is-hidden');
		}
	});
};

vars.$document.on('keydown', (e) => {
	if (e.keyCode === 27) {
		e.stopPropagation();

		hidePopup();
	}
});

vars.$document.on('click', (e) => {
	if (!$(e.target).closest('.card-popup').length) {
		if ($(e.target).hasClass('card__sidebar')) {
			openPopup(e);
		} else {
			hidePopup();
		}
	}

	if ($(e.target).closest('.card-popup__close').length) {
		hidePopup();
	}
});
